import { Heading, styled, Text } from "@sourceful/shared-components";
import toRem from "@styles/postprocess/conversion/to-rem";
import React, { ReactElement } from "react";

export const PRODUCT_CARD_WIDTH = 370 - 16;

const ProductCardWrapper = styled("figure", {
  borderRadius: toRem(8),
  boxShadow: "$lift",
  margin: toRem(8),
  display: "grid",
  gridTemplateRows: "max-content 1fr",
  width: `${PRODUCT_CARD_WIDTH}px`,
});

export const ImagePanel = styled("div", {
  aspectRatio: "1/1",
  img: {
    borderTopLeftRadius: toRem(8),
    borderTopRightRadius: toRem(8),
    width: "100%",
    height: "auto",
    objectFit: "cover",
  },
});

const DetailPanel = styled("div", {
  padding: toRem(20),
  paddingBottom: toRem(15),
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
});

const TextWrapper = styled("div", {});

export interface GenericProductCardProps {
  imageUrl: string;
  imageAlt?: string;
  title: string;
  subtitle?: string;
  renderCTA?: () => ReactElement;
  className?: string;
  children?: React.ReactNode;
}

const GenericProductCard: React.FC<GenericProductCardProps> = ({
  imageUrl,
  title,
  subtitle,
  renderCTA,
  children,
  className,
  imageAlt,
}) => {
  return (
    <ProductCardWrapper className={className || "product-card"}>
      <ImagePanel>
        <img src={imageUrl} alt={imageAlt || title} loading="lazy" width="100" height="100" />
      </ImagePanel>
      <DetailPanel>
        <TextWrapper>
          <Heading level={3} fontSize={6} prominence="secondary">
            {title}
          </Heading>
          <Text level={3}>{subtitle}</Text>
        </TextWrapper>
        {children}
        {renderCTA && renderCTA()}
      </DetailPanel>
    </ProductCardWrapper>
  );
};

export default GenericProductCard;
